<template>
  <div class="dialog-migrate-agent-wrapper">
    <el-dialog
      width="30%"
      :title="`迁移代理商（商户: ${user.username}）`"
      :visible="visible"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form ref="form" :rules="formRule" :model="formData">

        <!--代理商列表-->
        <el-form-item label="代理商" prop="agent">
          <el-select
            v-model="formData.agentid"
            style="width: 80%;">
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="`${agent.agentname}（${agent.nickname}）`"
              :value="agent.agentid" />
          </el-select>
        </el-form-item>

        <div class="submit-box">
          <el-button
            type="danger"
            @click="onFormSubmit">确定</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DialogMigrateAgent',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formRule: {
        agentid: [
          { required: true, message: '请选择迁移的目标代理商', trigger: 'change' }
        ]
      },
      formData: {
        agentid: ''
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ])
  },
  methods: {
    onDialogOpen () {
      if (this.user.agents && this.user.agents.length > 0) {
        this.formData.agentid = this.user.agents[0].agentid
      }
    },
    onDialogClose () {
      this.$emit('change', false)
      this.$refs['form'].resetFields()
    },
    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()
        this.$emit('submit', this.user.userid, this.formData.agentid)
        this.$emit('change', false)
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.onDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-migrate-agent-wrapper {

  .submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogMigrateAgent.vue